module.exports = __webpack_public_path__ + "23c3ca7a.svg";